import { addProp } from "@pnp/odata";
import { _User } from "../users/types.js";
import { Teams } from "./types.js";
addProp(_User, "joinedTeams", Teams, "joinedTeams");
//# sourceMappingURL=users.js.map